import { render, staticRenderFns } from "./BoardSectionEditor.vue?vue&type=template&id=7e24925e&scoped=true&"
import script from "./BoardSectionEditor.vue?vue&type=script&lang=ts&"
export * from "./BoardSectionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e24925e",
  null
  
)

export default component.exports